import INTERNAL_LINKS from "./InternalLinks";
import IconMedal from "images/icon-medal.svg";
import IconGlobal from "images/icon-global.svg";
import IconSearch from "images/icon-search.svg";

export default [
  {
    label: "Classes",
    icon: IconMedal,
    url: INTERNAL_LINKS.CLASSES,
  },
  {
    label: "Micro Class",
    icon: IconMedal,
    url: INTERNAL_LINKS.MICRO_CLASS,
  },

  {
    label: "Micro Conference",
    icon: IconGlobal,
    url: INTERNAL_LINKS.MICRO_CONFERENCE,
  },
  {
    label: "Global Conference",
    icon: IconGlobal,
    url: INTERNAL_LINKS.GLOBAL_CONFERENCE_SPEAKERS,
  },
  {
    label: "Global Conference",
    icon: IconGlobal,
    url: INTERNAL_LINKS.GLOBAL_CONFERENCE_PARTICIPANTS,
  },
  {
    label: "Global Conference",
    icon: IconGlobal,
    url: INTERNAL_LINKS.GLOBAL_CONFERENCE_PARTNERS,
  },
  {
    label: "Global Conference",
    icon: IconGlobal,
    url: INTERNAL_LINKS.GLOBAL_CONFERENCE_BONFIRE,
  },
  {
    label: "Global Conference",
    icon: IconGlobal,
    url: INTERNAL_LINKS.GLOBAL_CONFERENCE_PERSONAL_AGENDA,
  },
  {
    label: "Global Conference",
    icon: IconGlobal,
    url: INTERNAL_LINKS.GLOBAL_CONFERENCE_RECOMMENDED_AGENDA,
  },
  {
    label: "Global Conference",
    icon: IconGlobal,
    url: INTERNAL_LINKS.GLOBAL_CONFERENCE_LEADERBOARD,
  },
  {
    label: "Search Results",
    icon: IconSearch,
    url: INTERNAL_LINKS.SEARCH,
  },
];
